import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ children, content = {}, ...props }) => {
  return (
    <div className="header">
      <div className="avatar">
        <div className="wrap">
          <img src={`./images/resume/${content.avatar}`} alt={content.name} />
        </div>
      </div>

      <div className="info">
        <h1>{content.name}</h1>
        <h2>{content.title}</h2>
        <em>{content.subtitle}</em>
      </div>
    </div>
  );
};

Header.propTypes = {
  content: PropTypes.object.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/resume/Header.js